export default "__VITE_ASSET__C3z1bWiX__"